import React, { useEffect } from "react";
import {
  AppBar,
  Button,
  CircularProgress,
  CssBaseline,
  Fab,
  Hidden,
  IconButton,
  Toolbar,
} from "@material-ui/core";
import { useStylesBA, useStylesCAB } from "../../../../../St/comps/UseStyle";
import toast, { Toaster } from "react-hot-toast";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import AddBoxIcon from "@material-ui/icons/AddBox";
import SaveIcon from "@material-ui/icons/Save";
import PrintIcon from "@material-ui/icons/Print";
import { Fragment } from "react";
import { useState } from "react";
import { cellS, headerS, stElemnt } from "../../../../../St/comps/cStyle";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  ExchangeValidateSchema,
  PrepareData,
  ReFormatingData,
} from "../../../../../services/InernalVoucher-service";
import axios from "axios";
import { uri } from "../../../../../help/Api";
import { insh, sto } from "../../../../../Context/InshData";
import { useTranslation } from "react-i18next";
import { paymentType } from "../components/ReceiptVoucher-typeFilter";
import { Delete, Scanner } from "@material-ui/icons";
import SearchReaceiptCon from "../components/SearchRecipts/SearchReaceiptCon";
import ButtonsSearch from "../components/ButtonsSearch";
import { reloadGetsSanad } from "../external-receipt-voucher/EReceiptVoucher";
import DeleteConfirmDialog from "../../../../../components/DeleteConfirmDialog";
import SanadsPrint from "../../../../../Reviews/Accounts/voucharPrint/SanadsPrint";

var columnsInv = [
  { title: "الرقم", field: "id", headerStyle: headerS, cellStyle: cellS },
  { title: "التاريخ", field: "date", headerStyle: headerS, cellStyle: cellS },
  { title: "المبلغ", field: "val", headerStyle: headerS, cellStyle: cellS },
  {
    title: "مندوب المبيعات",
    field: "empName",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  {
    title: "المرجع",
    field: "check_no",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  {
    title: "الحساب",
    field: "custName",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  { title: "البيان", field: "notes", headerStyle: headerS, cellStyle: cellS },
];

export default function IReceiptVoucherAppBar(props) {
  const {
    submit,
    prmis,
    remove,
    update,
    onClose,
    defaultV,
    isDialog,
    submitting,
    onShow,
    object,
    URL,
    formType,
    getRow,
    AutoOptions,
    branch,
    branchT,
    setBranchT,
    AutoOptionsB,
    setOptionsStocks,
    db_name
  } = props;
  let his = useHistory();
  const { t } = useTranslation(["forms"]);

  const [openSearchMdl, setOpenSearchMdl] = useState(false);
  const clasBA = useStylesBA();
  const clasCAB = useStylesCAB();
  const styBtn = {
    dis: { color: "#3b773d", background: "#4fa152" },
    undis: { color: "#fff" },
  };

  const newEReceipt = () => {
    setOpenButtonsSearch(false);
    setProcIdSearch(0);
    reloadGetsSanad("sandqd", branch.id, onShow, defaultV);
    toast("إضافة سند جديد");
  };

  const addChangds = () => {
    object.date =
      moment(object.date).format("YYYY-MM-DD") +
      moment(new Date()).format(" h:mm A");
    // alert(formType);
    object.branch = formType === "edit" && !props.isDialogData ? branchT : props.isDialogData ? props.invData.branch : branch.id == -1 ? sto.branchi : branch.id;

  }
  const onSubmitHandle = (isPrint, isLarge = false) => {
    if (prmis?.FORCECOST === true && object?.center?.id < 1) {
      alert("لا يمكنك إتمام العملية برجاء التأكد من اختيار مركز التكلفة");
    } else {
      onSubmitHandleSave(isPrint, isLarge);
    }
  };

  const onSubmitHandleSave = (isPrint, isLarge = false) => {
    addChangds();
    let pData = PrepareData(object);
    let nData = {
      ...pData,
      cust_id: pData.emp_id,
    };
    console.log(" the data is", nData);
    const data = {
      sandQD: nData,
      parms: {
        bankAcc: parseInt(object?.bank?.i ?? 0),
        stockAcc: parseInt(object?.stock?.acc_no ?? 0),
        acc_no: parseInt(object?.acc_code?.code ?? 0),
        user: parseInt(object?.emp?.id ?? 0),
        cust_name: object?.acc_code?.name ?? "",
      },
      stor: { invsType: 1 },
      db_name: sto?.db_name,
    };
    console.log(nData);
    ExchangeValidateSchema.validate(nData, { abortEarly: false })
      .then(async () => {
        if (formType == "edit") {
          if (isPrint) handlePrint(nData, object, isLarge);
          else await update(data).then((res) => {
            if (res.data?.id == null) {
              toast.error(res.data);
              if (props.isDialogData === true) {
                props.onClose();
              }
            } else {
              if (props.isDialogData === true) {
                props.onClose();
              }
            }
          });
        } else {
          await submit(data).then((res) => {
            if (isPrint) handlePrint(res.data, object, isLarge);
            else { newObject(); }
            // toast.success('تم إضافة السند')
          });
        }
      })
      .catch((err) => {
        toast.error("erro");
        console.log(err);
      });
  };
  const [infoPrint, setInfoPrint] = useState(false);
  const [dataPrint, setDataPrint] = useState({});
  const closePrint = (type) => {
    newEReceipt();
    setDataPrint({});
    setInfoPrint(false);
  };

  const handlePrint = (rptdata, oldObject, isLarge) => {
    const info = {
      columns: columnsInv,
      temp: 2,
      data: rptdata,
      custN: "دفعة من حساب",

      from: "القبض",
      title: "سند قبض - داخلي",
      subTitle: "Internal Receipt Voucher",
      label: "استلمت من السيد",
      auto: {
        empName: oldObject.emp.name,
        center: oldObject.center.name,
        custName: oldObject.acc_code.name,
        stockName:
          rptdata?.type == 1 ? oldObject.stock?.name : oldObject.bank?.name,
        type: t(paymentType[rptdata?.type - 1].name),
      },
      //   fDate:dateFrom,tDate:dateTo,
      Date: moment(rptdata.date).format("YYYY-MM-DD"),
      ElmntShow: true,
      db_name: db_name,
      isLarge: isLarge,
    };
    setDataPrint(info);
    setInfoPrint(true);
    // localStorage.setItem("iInfos", JSON.stringify(info));
    // if (isLarge) his.push({ pathname: "/voucher2" });
    // else his.push({ pathname: "/SC" });
    // window.location.reload(false);
  };
  const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
  const [procIdSearch, setProcIdSearch] = useState(0);
  const onClickButton = async (procId, type) => {
    const tb = {
      wait: true,
      ButtonSearchSand: true,
      stor: sto,
      parms: {
        tname: type,
        branch: branch.id == -1 ? sto.branchi : branch.id,
        iprocid: procId,
        iempid: sto.idi,
        type: "2",
        db_name: db_name,
      },
    };
    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setProcIdSearch(res.data?.Sand_data?.id);
        if (res.data?.Sand_data.id > 0) {
          onRowClick({
            ...res.data.Sand_data,
            acc_name: res?.data?.Sand_data?.acc_name,
            custName: res.data.Sand_data?.acc_name,
            emp_id: res.data.Sand_data?.sales_emp,
          });
        }
      })
      .catch((error) => {
      });
  };
  const onRowClick = (row) => {
    setBranchT(row?.branch);
    setProcIdSearch(row?.id);
    setOpenButtonsSearch(true);
    const tb = {
      Stocks: true, // Error // out
      parms: {
        branch: row?.branch,
        ibranchid: row?.branch,
        iempid: sto.empi,
        withOmlat: true,
        db_name: db_name,
      },
    };

    axios
      .post(uri + "Res", tb)
      .then((res) => {
        setOptionsStocks(res.data?.Stocks);
        const optinsNew = {
          ...AutoOptions,
          Stocks: res.data?.Stocks,
        };
        onRowClickAfter({ ...row }, optinsNew);
      })
      .catch((error) => {
      });
  };

  const onRowClickAfter = async (row, optinsNew) => {
    setBranchT(row?.branch);
    let FormatedData = ReFormatingData(
      { ...row, emp_id: row.cust_id },
      optinsNew
    );
    // console.log("the data is after ", FormatedData);
    let end_dept1 = "0.0";
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `AccountReports/rptABalanceSum?branch=${row.branch}&&costCenter=${-1}
        &&acc_code=${FormatedData.acc_code.code.toString()}`
    } else {
      Urls = `AccountReports/rptABalanceSum?branch=${row.branch}&&costCenter=${-1}
        &&acc_code=${FormatedData.acc_code.code.toString()}&&db_name=${db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        end_dept1 = res.data.end_Dept - res.data.end_Credit;
      })
      .catch((res) => { });
    setOpenSearchMdl(false);
    onShow({ ...FormatedData, end_Dept: end_dept1 }, "edit");
  };


  const onRowDialog = async () => {
    if (props.isDialogData === true) {
      let data = props.invData;
      const data2 = {
        ...data,
        acc_name: data.acc_name,
        custName: data.acc_name,
        emp_id: data.cust_id,
      }
      let FormatedData = ReFormatingData(
        data2,
        AutoOptions
      );
      let end_dept1 = "0.0";
      let Urls = null;
      if (sto.db_name === "" || sto.db_name === null) {
        Urls = `AccountReports/rptABalanceSum?branch=${data.branch}&&costCenter=${-1}
          &&acc_code=${FormatedData.acc_code.code.toString()}`
      } else {
        Urls = `AccountReports/rptABalanceSum?branch=${data.branch}&&costCenter=${-1}
          &&acc_code=${FormatedData.acc_code.code.toString()}&&db_name=${db_name}`
      }
      await axios
        .get(
          uri + Urls
        )
        .then((res) => {
          end_dept1 = res.data.end_Dept - res.data.end_Credit;
        })
        .catch((res) => { });
      setOpenSearchMdl(false);
      onShow({ ...FormatedData, end_Dept: end_dept1 }, "edit");
    }
  };


  useEffect(() => {
    onRowDialog();
  }, []);
  const [loading, setLoading] = useState(insh.LoadAndSucc);
  const [success, setSuccess] = useState(insh.LoadAndSucc);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
  const ButtonLoading = (prop) => {
    setLoading({ ...loading, [prop]: true });
  };
  const timer = React.useRef();
  const ButtonSuccess = (prop, state) => {
    timer.current = window.setTimeout(() => {
      setLoading({ ...loading, [prop]: false });
      setSuccess({ ...success, [prop]: true });
      if (
        prop == "delete"
      ) {
        if (state) newObject();
        // reopen();
      }
      timer.current = window.setTimeout(() => {
        setSuccess({ ...success, [prop]: false });
      }, 100);
    }, 1000);
  };
  const newObject = () => {
    setOpenButtonsSearch(false);
    setProcIdSearch(0);
    reloadGetsSanad("sandqd", branch.id, onShow, defaultV);
  };
  const onDeleteHandle = async (e) => {
    await e.preventDefault();
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    ButtonLoading("delete");
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `SandQD?id=${object.id}&&branch=${object.branch}`
    } else {
      Urls = `SandQD?id=${object.id}&&branch=${object.branch}&&db_name=${db_name}`
    }
    await axios.delete(uri + Urls).then(res => {

      if (parseFloat(res.data) > 0) {
        toast.success("لقد تم حذف السند بنجاح");

        if (props.isDialogData === true) {
          props.onClose();
        } else { ButtonSuccess("delete", true); }

      } else {
        toast.error(res.data);
        if (props.isDialogData === true) {
          { props.onClose(); }
        } else { ButtonSuccess("delete", true); }

      }
    }).catch(err => {
      if (err.response?.data?.Message != null) {
        toast.error(err.response?.data?.Message);
      } else
        console.log("eror", err)
      ButtonSuccess("delete", false);
      toast.error("not delete ")
    })
  };

  const backHome = () => {
    if (isDialog) onClose();
    else {
      his.push({ pathname: "/" });
      window.location.reload(false);
    }
  };
  const [transition, setTransition] = React.useState(undefined);
  const [isInternal, setIsInternal] = useState(true);

  let type = 1;
  let tname = "2";
  const handCloseDw = () => {

    setOpenSearchMdl(false);
  };
  return (
    <React.Fragment>
      <Toaster />
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clasBA.appBarBASal}
        style={{ backgroundColor: "#808080" }}
      >
        <Toolbar className={clasBA.ToolbarBA} variant="dense">
          {props.isDialogData ?
            (
              <>
                <Hidden smUp={["sm"]}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="backH"
                    onClick={props.onClose}
                  >
                    <CloseIcon />
                  </IconButton>

                </Hidden>

                <Hidden only={["xs"]}>
                  <Button
                    style={styBtn.undis}
                    onClick={props.onClose}
                    startIcon={<CloseIcon />}
                  >
                    {t("exit")}
                  </Button>

                </Hidden></>
            )
            :
            (
              <>
                <Hidden smUp={["sm"]}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="backH"
                    onClick={backHome}
                  >
                    <CloseIcon />
                  </IconButton>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="searsh"
                    disabled={prmis?.Se}
                    onClick={() => setOpenSearchMdl(true)}
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="handNew"
                    onClick={newEReceipt}
                  >
                    <AddBoxIcon />
                  </IconButton>
                </Hidden>

                <Hidden only={["xs"]}>
                  <Button
                    style={styBtn.undis}
                    onClick={backHome}
                    startIcon={<CloseIcon />}
                  >
                    {t("exit")}
                  </Button>
                  <Button
                    style={styBtn.undis}
                    disabled={prmis?.Se}
                    onClick={() => setOpenSearchMdl(true)}
                    startIcon={<SearchIcon />}
                  >
                    {t("search")}
                  </Button>
                  <Button
                    style={styBtn.undis}
                    onClick={newEReceipt}
                    startIcon={<AddBoxIcon />}
                  >
                    {t("new")}
                  </Button>
                </Hidden></>
            )
          }
          {!props.isDialogData && (
            <Hidden only={["xs"]}>
              <ButtonsSearch
                {...{
                  onClickButton, openButtonsSearch, procIdSearch, setOpenButtonsSearch
                }}
              />
            </Hidden>
          )}


          <div className={clasBA.growBA} />

          <Hidden smUp={["sm"]}>
            {formType == "edit" && (
              <div className={clasCAB.wrapperCAB}>
                <Fab
                  size="medium"
                  color="primary"
                  // disabled
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={submitting || prmis?.De}
                  className={clasCAB.buttonSuccessCAB}
                  onClick={(e) => {
                    setConfirmDialog({
                      isOpen: true,
                      onConfirm: () => {
                        onDeleteHandle(e);
                      },
                    })
                  }}
                >
                  <Delete />
                </Fab>

                {submitting && (
                  <CircularProgress
                    size={56}
                    className={clasCAB.fabProgressCAB}
                  />
                )}
              </div>
            )}

            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting ||
                  (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                }
                onClick={() => {
                  onSubmitHandle(true);
                }}
              >
                <Scanner />
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>
            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting ||
                  (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                }
                onClick={() => {
                  onSubmitHandle(true, true);
                }}
              >
                <PrintIcon />
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>

            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)
                }
                onClick={() => onSubmitHandle(false)}
              >
                {" "}
                <SaveIcon />
              </Fab>

              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>
          </Hidden>

          <Hidden only={["xs"]}>
            <Fragment>
              {formType == "edit" && (
                <>

                  <div className={clasCAB.wrapperCAB}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={clasCAB.buttonSuccessCAB}
                      startIcon={<Delete />}
                      style={{
                        ...stElemnt.all.iconBtn,
                        backgroundColor: "#808080",
                      }}
                      disabled={submitting || prmis.De}
                      onClick={(e) => {
                        setConfirmDialog({
                          isOpen: true,
                          onConfirm: () => {
                            onDeleteHandle(e);
                          },
                        })
                      }}
                    >
                      {t("delete")}
                    </Button>

                    {submitting && (
                      <CircularProgress
                        size={24}
                        className={clasCAB.buttonProgressCAB}
                      />
                    )}
                  </div>
                </>
              )}
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={clasCAB.buttonSuccessCAB}
                  startIcon={<Scanner />}
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={
                    submitting ||
                    (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                  }
                  onClick={() => onSubmitHandle(true)}
                >
                  {" "}
                  {t("cashier-view")}
                </Button>

                {submitting && (
                  <CircularProgress
                    size={24}
                    className={clasCAB.buttonProgressCAB}
                  />
                )}
              </div>
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={clasCAB.buttonSuccessCAB}
                  startIcon={<PrintIcon />}
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={
                    submitting ||
                    (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                  }
                  onClick={() => onSubmitHandle(true, true)}
                >
                  {" "}
                  {formType == "edit" ? t("print") : t("save-print")}
                </Button>
                {submitting && (
                  <CircularProgress
                    size={24}
                    className={clasCAB.buttonProgressCAB}
                  />
                )}
              </div>
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  className={clasCAB.buttonSuccessCAB}
                  disabled={
                    submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)
                  }
                  onClick={() => onSubmitHandle(false)}
                  startIcon={<SaveIcon />}
                >
                  {formType == "edit" ? t("save-update") : t("save")}
                </Button>
                {submitting && (
                  <CircularProgress
                    size={24}
                    className={clasCAB.buttonProgressCAB}
                  />
                )}
              </div>
            </Fragment>
          </Hidden>
        </Toolbar>
      </AppBar>
      {confirmDialog.isOpen && (
        <DeleteConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      )}
      {openSearchMdl && (
        <SearchReaceiptCon
          {...{
            openSearchMdl, handCloseDw,
            onRowClick, URL, type, tname, AutoOptions, transition, isInternal,
            AutoOptionsB,
          }}
        />
      )}
      {infoPrint ? <SanadsPrint dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}
    </React.Fragment>
  );
}
